import BillingClaim from './BillingClaim';

export default BillingClaim;
